// extracted by mini-css-extract-plugin
export default {"title":"mYh3f8qPcX","field":"L12fNhLUqx","dark":"ATPIjgk8Tl"};